export default __webpack_public_path__ + "static/insertion-149f298cd80ff2836a3283c3e0ee78b7.png";